import {
  type QueryClient,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { api, unwrap } from "@/shared/lib/apiClient";
import {
  overviewKeys,
  raidContentKeys,
  setupKeys,
} from "@/shared/lib/queryKeys";
import type { RaidFormValues } from "../raid-day.schemas";

const invalidateRaidDependents = (queryClient: QueryClient) => {
  queryClient.invalidateQueries({ queryKey: overviewKeys.all });
  queryClient.invalidateQueries({ queryKey: setupKeys.all });
  queryClient.invalidateQueries({ queryKey: raidContentKeys.all });
};

export function useCreateRaid() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (body: RaidFormValues) =>
      unwrap(await api.POST("/api/raids", { body })),
    onSuccess: () => invalidateRaidDependents(queryClient),
  });
}

export function useUpdateRaid() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, ...body }: RaidFormValues & { id: string }) =>
      unwrap(
        await api.PUT("/api/raids/{id}", {
          params: { path: { id } },
          body,
        }),
      ),
    onSuccess: () => invalidateRaidDependents(queryClient),
  });
}

export function useDeleteRaid() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      unwrap(await api.DELETE("/api/raids/{id}", { params: { path: { id } } }));
    },
    onSuccess: () => invalidateRaidDependents(queryClient),
  });
}
